"use client";

import dynamic from "next/dynamic";
import { isValidPhoneNumber } from "react-phone-number-input";

// Import CSS at top level - it will be bundled with the dynamic component chunk
// Since the component is dynamically imported, the CSS will also be lazy-loaded
import "react-phone-number-input/style.css";

// Dynamically import PhoneInput to reduce initial bundle size
const PhoneInput = dynamic(
  () => import("react-phone-number-input").then((mod) => mod.default),
  {
    ssr: false,
    loading: () => (
      <div className="w-full px-4 py-3 text-sm font-light text-ui-card bg-ui-page border border-ui-border rounded-none animate-pulse">
        <div className="h-5 bg-ui-border rounded"></div>
      </div>
    ),
  }
);

type DynamicPhoneInputProps = {
  value: string;
  onChange: (value: string | undefined) => void;
  onBlur: () => void;
  placeholder: string;
  className: string;
  style?: React.CSSProperties;
  touched?: boolean;
  error?: boolean;
  "aria-required"?: boolean;
};

export default function DynamicPhoneInput({
  value,
  onChange,
  onBlur,
  placeholder,
  className,
  style,
  touched,
  error,
  "aria-required": ariaRequired,
}: DynamicPhoneInputProps) {
  return (
    <PhoneInput
      international
      defaultCountry="GR"
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      placeholder={placeholder}
      className={className}
      style={style}
      autoComplete="tel"
      aria-required={ariaRequired}
    />
  );
}

// Export validation function for use in parent component
export { isValidPhoneNumber };

